const HEADLESS_OPTIONS_LIMIT = 200

// Use this helper to limit the number of options displayed in a headless UI component.
// This is a temporary solution until we have a better solution for large lists.
// This should be used only at the time of rendering and not as part of any logic
export function renderHeadlessSafeItems<T>(items: T[]): T[] {
  return items.slice(0, HEADLESS_OPTIONS_LIMIT)
}
